module.exports = __webpack_public_path__ + "img/20190527162721475.4413a8f0.png";